import React from 'react';
import { Mail, MessageCircle, FileText, ExternalLink } from 'lucide-react';

const SupportContent = () => {
  const supportOptions = [
    {
      icon: Mail,
      title: "Email Support",
      description: "Get help from our support team",
      action: "support@pebbletheapp.com",
      href: "mailto:support@pebbletheapp.com",
    },
    {
      icon: FileText,
      title: "FAQs",
      description: "Find answers to common questions",
      action: "View FAQs",
      href: "/faqs",
    },
    {
      icon: MessageCircle,
      title: "Live Chat",
      description: "Chat with us in real-time",
      action: "Coming Soon",
      href: "#",
      comingSoon: true,
    },
  ];

  return (
    <div className="p-6 max-w-4xl mx-auto">
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-gray-900 mb-2">Support</h1>
        <p className="text-gray-600">Need help? We're here for you.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
        {supportOptions.map((option, index) => {
          const isDisabled = option.comingSoon || option.isPro;
          const CardWrapper = isDisabled ? 'div' : 'a';
          const cardProps = isDisabled ? {} : { href: option.href };
          return (
          <CardWrapper
            key={index}
            {...cardProps}
            className={`block bg-white rounded-xl border ${option.isPro ? 'border-purple-200' : 'border-gray-200'} p-5 hover:shadow-md transition-shadow ${isDisabled ? 'opacity-75 cursor-not-allowed' : ''}`}
          >
            <div className="flex items-center gap-3 mb-3">
              <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${option.isPro ? 'bg-gradient-to-br from-purple-500 to-indigo-600' : 'bg-red-50'}`}>
                <option.icon className={`h-5 w-5 ${option.isPro ? 'text-white' : 'text-pebble-red'}`} />
              </div>
              {option.comingSoon && (
                <span className="px-2 py-0.5 bg-gray-100 text-gray-500 text-xs rounded-full">Coming Soon</span>
              )}
              {option.isPro && (
                <span className="px-2 py-0.5 bg-gradient-to-r from-purple-500 to-indigo-500 text-white text-xs font-medium rounded-full">PRO</span>
              )}
            </div>
            <h3 className="font-semibold text-gray-900 mb-1">{option.title}</h3>
            <p className="text-sm text-gray-500 mb-3">{option.description}</p>
            <span className="text-sm font-medium text-pebble-red flex items-center gap-1">
              {option.action}
              <ExternalLink className="h-3 w-3" />
            </span>
          </CardWrapper>
        );
        })}
      </div>

      <div className="bg-white rounded-xl border border-gray-200 p-6">
        <h2 className="text-lg font-semibold text-gray-900 mb-4">Contact Form</h2>
        <form className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Subject</label>
            <select className="w-full h-10 px-3 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-pebble-red focus:border-transparent">
              <option value="">Select a topic</option>
              <option value="account">Account Issues</option>
              <option value="billing">Billing & Payments</option>
              <option value="events">Event Management</option>
              <option value="technical">Technical Support</option>
              <option value="bug">Report a Bug</option>
              <option value="feature">Feature Request</option>
              <option value="other">Other</option>
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Message</label>
            <textarea 
              rows={4}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-pebble-red focus:border-transparent resize-none"
              placeholder="Describe your issue or question..."
            />
          </div>
          <button
            type="submit"
            className="px-4 py-2 bg-pebble-red text-white rounded-lg text-sm font-medium hover:bg-pebble-red/90"
          >
            Send Message
          </button>
        </form>
      </div>

      <div className="mt-8 text-center text-sm text-gray-500">
        <p>Support hours: Monday - Friday, 9am - 6pm EST</p>
        <p className="mt-1">Average response time: Within 24 hours</p>
      </div>
    </div>
  );
};

export default SupportContent;
